import { dataHooks } from '@wix/data-hooks'

export const wixIntrosRadiogroupDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  radioGroup: {}
  submitButton: {}
}>('wix-intros-radiogroup')
